var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-attachment","label":_vm.$t('integrations.fields.link_to_json'),"hide-label":_vm.hideLabel,"text":""},on:{"click":function($event){return _vm.showOrder(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }